import React from "react";

const MenuContext = React.createContext();
MenuContext.displayName = "MenuContext";

export default MenuContext;